import { CanDeactivateFn } from '@angular/router';

/** A page that has something to lose when the user navigates away. */
export interface HasPendingChanges {
  canDeactivate(): boolean | Promise<boolean>;
}

export const PendingChangesGuard: CanDeactivateFn<HasPendingChanges> = (component) =>
  component.canDeactivate();
